import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../shared/services/menu.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../shared/services/loca-storage.service';

@Component({
  selector: 'app-reception-advanced-doeq',
  templateUrl: './reception-advanced-doeq.component.html',
  styleUrls: ['./reception-advanced-doeq.component.scss']
})
export class ReceptionAdvancedDoeqComponent implements OnInit {

  menuSlide: any[] = [];
  
  constructor(
    public menu: MenuService,
    private router: Router,
    private storageService: LocalStorageService
  ) {

    let cantItems: number = 9;
    let tmp: number = 0;
    let arrtmp: any[] = [];

    this.storageService.get('auth_user').then((user: any) => {
      const urls = this.router.routerState.snapshot.url.split('/');
      const menuItems = this.menu.getNavMenu(urls[1]);
      const items: any[] = [];

      menuItems.forEach((item) => {
        item.main.forEach((element) => {
          items.push(element);
        });
      });


      items.forEach((element, index) => {
        if (tmp < cantItems) {
          arrtmp.push(element);
          tmp = tmp + 1;
        }

        if ((index == items.length - 1) || (tmp >= cantItems)) {
          this.menuSlide.push({ items: arrtmp });
          tmp = 0;
          arrtmp = [];
        }
      });
    }).catch((e) => {
      console.log('ContentLayoutComponent->ngAfterViewInit', e);
    });
  }

  ngOnInit() {
  }

  action(item) {
    if (item.type === 'link') {
      if (item.main_state) {
        this.router.navigate([`/${item.main_state}/${item.state}`]);
      } else {
        this.router.navigate([`/${item.state}`]);
      }
      return;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/reception-advanced-doeq/reception-advanced-doeq.component.ts